import { render, staticRenderFns } from "./Charge.vue?vue&type=template&id=b6a97b9a"
import script from "./Charge.vue?vue&type=script&lang=js"
export * from "./Charge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports